import React, { Component } from "react";
import { Tabs } from "antd";
import { Card } from "antd";
import "./Orders.scss"
import ContactTab from "../../components/Tabs/ContactTab";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

class Orders extends Component {
  state = {
    activeTab: '1',
  }

  callback = (key) => {
    this.setState({activeTab : key})
  };

  componentDidMount() {
    const {match : {params}} = this.props;
    //console.log(params);
    params.tab ? this.setState({activeTab : params.tab}) : this.setState({activeTab: '1'})
  }

  render() {
    return (
      <div className="orders-wrapper">
        <div className="container">
          <ContactTab title="الطلبات" /> 
        </div>
      </div>
      
    );
  }
}

const mapStateToProps = (state) => ({
  currentLang : state.user.currentLang,
}) 

const OrdersWithRouter = withRouter(Orders);
export default connect(mapStateToProps)(OrdersWithRouter);